/**
 * 页面路由数据
 */

 import asyncComponent from "./asyncComponent.js";
 import {useData} from './useData.js'
 
 const Index =  asyncComponent(() => import('entry/main/MainCon.jsx'))
 const Getpwd = asyncComponent(() => import('pages/getpwd/FindPWD.jsx'))
 const Register = asyncComponent(() => import('pages/register/Register.jsx'))
 const AccMerge = asyncComponent(() => import('pages/merge/AccMerge.jsx'))
 const ActivateInit = asyncComponent(() => import('pages/activate/activate.js'))
 const NCActivateInit = asyncComponent(() => import('pages/activate_nc/ActivateInit.jsx'))
 const NCYanzhengActivateInit = asyncComponent(() => import('pages/activate_nc_yanzheng/ActivateInit.jsx'))
 const ValidationInit = asyncComponent(() => import('pages/validation/ValidationInit.jsx'))
 const BindWechatEntry = asyncComponent(() => import('pages/bindwechat/BindWechatEntry.jsx'))
 const CensorWords = asyncComponent(() => import('pages/censorwords/CensorWords.jsx'))
 const DiworkUser = asyncComponent(() => import('pages/diwork_user/DiworkUserEntry.jsx'))
 const ThirdMerge = asyncComponent(() => import('pages/third_merge/MergeEntry.jsx'))
 const ChangePWEntry = asyncComponent(() => import('mobilepages/mobile_changepw/ChangePWEntry.jsx'))
 const Genpsw = asyncComponent(() => import('pages/genpsw/GenPsw.jsx'))
 const Risk = asyncComponent(() => import('pages/risk'))
 
 const indexData=[
     /** 帐号申诉 */
     // require('entry/routes/appealchange')
     // require('entry/routes/appeal')
     {
         id: "1",
         path: "/",
         component: Index,
         exact: true,
         
     },
     {
         id: "getpwd",
         path: "/getpwd",
         component: Getpwd,
         exact: true,
         
     },
     {
         path: '/register',
         component: Register,
         exact: true,
       },
     {
         id: "merge",
         path: "/merge",
         component: AccMerge,
         exact: true,
          //X
     },
     {
         id: "activate",
         path: "/activate",
         component: ActivateInit,
         exact: true,
         
     },
     {
         id: "ncactivate",/** NC激活 */
         path: "/ncactivate",
         component: NCActivateInit,
         exact: true,
     },
     {
         id: "ncactivate_yanzheng",/** NC验证激活 */
         path: "/ncactivate_yanzheng",
         component: NCYanzhengActivateInit,
         exact: true,
         
     },
     {
         id: "validation",/** 用户验证 */
         path: "/validation",
         component: ValidationInit,
         exact: true,
         
     },
     {
         id: "bindwechat",/** 扫码登陆后绑定微信 */
         path: "/bindwechat",
         component: BindWechatEntry,
         exact: true,
         
     },
     {
         id: "censorwords",/** 敏感词检查 */
         path: "/censorwords",
         component: CensorWords,
         exact: true,
     },
     {
         id: "diuser",/** diwork帐号管理 */
         path: "/diuser",
         component: DiworkUser,
         exact: true,
          //---有问题
     },
     {
         id: "thirdmerge",/** 第三方登录帐号合并 */
         path: "/thirdmerge",
         component: ThirdMerge,
         exact: true,
          //---有问题
     },
     {
         id: "mchangepw",/** 移动端修改密码 */
         path: "/mchangepw",
         component: ChangePWEntry,
         exact: true,
     },
     {
         id: "genpsw",/** 专属云密码配置页面 */
         path: "/genpsw",
         component: Genpsw,
         exact: true,
         
     },
     {
         id: "risk",/** 风控跳转页面 */
         path: "/risk",
         component: Risk,
         exact: true,
         
     }
     
     
 ];
 
 const routerData=indexData.concat(useData)
 export default routerData
 
 
 